<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Referencias/Derivaciones</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de referencias y derivaciones"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Referencias / Derivaciones">
  <AyudaReferencia />
</Modal>

    <hr>

    <!--  DataTable  -->
    <DataTable
      :data="referencias"
      :columns="columnas"
      idField="idReferencia"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarEditar="false"
      :mostrarVer="true"
      :mostrarEliminar="false"
      mensajeVacio="No hay referencias disponibles."
      @refresh="cargarTodos()"
      @info="row => abrirModalEditar(row.idReferencia)"
      @view="row => abrirEditar(row.idReferencia)"
    >
      <!-- Celda: Fecha referencia -->
      <template #cell-fechaRef="{ row }">
        {{ getFormattedDate(row.fechaRef) }}
      </template>

      <template #acciones-fila="{ row }">
        <select class="form-select form-select-sm"
                @change="handleAction($event, row.idReferencia)"
                @click.stop>
          <option disabled selected>Seleccione...</option>
          <option value="editar">Editar</option>
          <option value="detalles">Detalles</option>
          <option value="formulario">Formulario informe</option>
        </select>
      </template>
    </DataTable>

    <!--  Modal resumen referencia  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalReferenciaLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalReferenciaLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2" v-for="campo in camposModal" :key="campo.label">
              <div class="col-3">
                <label class="fw-bold">{{ campo.label }}</label>
              </div>
              <div class="col-9">
                <span class="form-control-plaintext"
                      :style="campo.upper ? 'text-transform:uppercase' : ''">
                  {{ campo.valor }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from '@/components/Layout.vue'
import Footer          from '@/components/Footer.vue'
import AyudaReferencia from '@/views/ayuda/AyudaReferencia.vue'
import DataTable       from '@/components/DataTable.vue'
import dateFormat      from '@/modules/dateFormat.js'
import api             from '@/services/api'
import { openModal }   from '@/modules/modalHelper.js'

export default {
  name: 'Referencias',
  components: { Layout, Footer, AyudaReferencia, DataTable },

  data() {
    return {
      referencias:    [],
      datoReferencia: {},
      titulo:         '',
      modalWindow:    true,
      showModalHelp:  false,

      // Columnas para DataTable
columnas: [
  { field: 'fechaRef',       label: 'Fecha Ref.' },
  { field: 'hora',           label: 'Hora' },
  { field: 'pacienteNombre', label: 'Nombre' },
  {
    field: 'tipo',
    label: 'Tipo',
    filterType: 'select',
    filterOptions: ['REFERENCIA', 'DERIVACION'],
  },
  {
    field: 'motivoRefNombre',
    label: 'Motivo',
    filterType: 'select',
    filterOptions: [],
  },
],
    }
  },

  computed: {
    camposModal() {
      const d = this.datoReferencia
      return [
        { label: 'ID de Referencia',   valor: d.idReferencia },
        { label: 'Motivo de Referencia',valor: d.motivoRefNombre },
        { label: 'Empresa de Origen',  valor: d.empresaOrigen },
        { label: 'Empresa de Destino', valor: d.empresaDestino },
        { label: 'Nombre del Paciente',valor: d.pacienteNombre },
        { label: 'Nombre del Médico',  valor: d.medicoNombre },
        { label: 'Fecha de Registro',  valor: this.getFormattedDate(d.fechaReg) },
        { label: 'Fecha de Referencia',valor: this.getFormattedDate(d.fechaRef) },
        { label: 'Hora',               valor: d.hora,         upper: true },
        { label: 'Tipo',               valor: d.tipo,         upper: true },
        { label: 'Motivo',             valor: d.motivo,       upper: true },
        { label: 'Resumen',            valor: d.resumen,      upper: true },
        { label: 'Hallazgos',          valor: d.hallazgos,    upper: true },
        { label: 'Tratamiento',        valor: d.tratamiento,  upper: true },
        { label: 'Justificación',      valor: d.justificada,  upper: true },
      ]
    },
  opcionesMotivo() {
    const set = new Set(this.referencias.map(r => r.motivoRefNombre).filter(Boolean))
    return [...set].sort()
  },
},

watch: {
  opcionesMotivo(vals) {
    const col = this.columnas.find(c => c.field === 'motivoRefNombre')
    if (col) col.filterOptions = vals
  },
},

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.cargarTodos()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    //  Carga de datos
    cargarTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      this.fetchReferencias(`/vwreferencias/idempresaorigen/${idEmpresa}`)
    },

    fetchReferencias(url) {
      api.get(url)
        .then(response  => { this.referencias = response.data.reverse() })
        .catch(error    => console.error('Error al obtener referencias:', error))
    },

    //  Acciones del select por fila
    handleAction(event, idReferencia) {
      const action = event.target.value
      if      (action === 'editar')     this.abrirModalEditar(idReferencia)
      else if (action === 'detalles')   this.abrirEditar(idReferencia)
      else if (action === 'formulario') this.formulario007informePDF(idReferencia)
      event.target.value = 'Seleccione...'
    },

    abrirModalEditar(idReferencia) {
      this.modalWindow = true
      if (idReferencia) {
        api.get(`/vwreferencias/${idReferencia}`)
          .then(resp => { this.datoReferencia = resp.data })
      }
      openModal('ventanaModal')
      this.titulo = 'Resumen de la Referencia/Derivación'
    },

    abrirEditar(idReferencia) {
      if (idReferencia) this.$router.push(`/referenciaform/0/0/${idReferencia}/0/R`)
    },

    formulario007informePDF(idReferencia) {
      const url = `/api/v1/reportes/pdf/referencia/${idReferencia}`
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.modal-body label { font-weight: bold; }
</style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style>
.busqueda-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.busqueda-campo {
  display: flex;
  flex-direction: column;
  min-width: 130px;
  flex: 1;
}
.busqueda-campo--lg { flex: 3 1 260px; }

.busqueda-bar .form-label {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #6c757d;
}

.btn-icono {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  padding: 6px 12px;
  flex-shrink: 0;
}

.btn-label { font-size: 14px; }

@media (max-width: 576px) {
  .busqueda-campo,
  .busqueda-campo--lg { flex: 1 1 100%; }
  .btn-icono { width: 100%; }
}
</style>